// InfiltrationForm.jsx
import { useState, useEffect } from "react"
import "../../css/DemoCode.css"

/**
 * Infiltration Form is a group of data inputs usually shown when clicking on Subcatchment->Infiltration Data. 
 * This form is contained within InfiltrationDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} infilMethod The type of infiltration method used by the subcatchment.
 * @param {string} target The name of the node targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function InfiltrationForm({model, setModel, infilMethod, target}) {
  const [param1, setParam1] = useState(model.INFILTRATION[target].Param1)
  const [param2, setParam2] = useState(model.INFILTRATION[target].Param2)
  const [param3, setParam3] = useState(model.INFILTRATION[target].Param3)
  const [param4, setParam4] = useState(model.INFILTRATION[target].Param4)
  const [param5, setParam5] = useState(model.INFILTRATION[target].Param5)

  useEffect(()=>{
      setParam1(model.INFILTRATION[target].Param1)
      setParam2(model.INFILTRATION[target].Param2)
      setParam3(model.INFILTRATION[target].Param3)
      setParam4(model.INFILTRATION[target].Param4)
      setParam5(model.INFILTRATION[target].Param5)
  }, )

  const updateValue = (val, type) => {
    if(model && model.INFILTRATION){
      setModel(prev => ({
        ...prev,
        INFILTRATION:{
          ...prev.INFILTRATION,
          [target]: {
            ...prev.INFILTRATION[target],
            [type]: val
          }
        }
      }))
    }
  }

  if(model){
    return(
      <>
      {
        <>
          {(
            target && 
            target.length > 0 && 
            (infilMethod === 'HORTON' || infilMethod === 'MODIFIED_HORTON') &&
            <>
            <label className='editor-small' >Max. Infil. Rate
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam1(); updateValue(e.target.value, 'Param1')}}
                      value={param1}
                      id={'Param1_'+target}
              />
            </label>
            <label className='editor-small' >Min. Infil. Rate
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam2(); updateValue(e.target.value, 'Param2')}}
                      value={param2}
                      id={'Param2_'+target}
              />
            </label>
            <label className='editor-small' >Decay Constant
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam3(); updateValue(e.target.value, 'Param3')}}
                      value={param3}
                      id={'Param3_'+target}
              />
            </label>
            <label className='editor-small' >Drying Time
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam4(); updateValue(e.target.value, 'Param4')}}
                      value={param4}
                      id={'Param4_'+target}
              />
            </label>
            <label className='editor-small' >Max. Volume
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam5(); updateValue(e.target.value, 'Param5')}}
                      value={param5}
                      id={'Param5_'+target}
              />
            </label>
            </>
          )}
          {(
            target && 
            target.length > 0 && 
            (infilMethod === 'GREEN_AMPT' || infilMethod === 'MODIFIED_GREEN_AMPT') &&
            <>
            <label className='editor-small' >Suction Head
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam1(); updateValue(e.target.value, 'Param1')}}
                      value={param1}
                      id={'Param1_'+target}
              />
            </label>
            <label className='editor-small' >Conductivity
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam2(); updateValue(e.target.value, 'Param2')}}
                      value={param2}
                      id={'Param2_'+target}
              />
            </label>
            <label className='editor-small' >Initial Deficit
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam3(); updateValue(e.target.value, 'Param3')}}
                      value={param3}
                      id={'Param3_'+target}
              />
            </label>
            </>
          )}
          {(
            target && 
            target.length > 0 && 
            (infilMethod === 'CURVE_NUMBER') &&
            <>
            <label className='editor-small' >Curve Number
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam1(); updateValue(e.target.value, 'Param1')}}
                      value={param1}
                      id={'Param1_'+target}
              />
            </label>
            <label className='editor-small' >Conductivity
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam2(); updateValue(e.target.value, 'Param2')}}
                      value={param2}
                      id={'Param2_'+target}
              />
            </label>
            <label className='editor-small' >Drying Time
              <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{setParam3(); updateValue(e.target.value, 'Param3')}}
                      value={param3}
                      id={'Param3_'+target}
              />
            </label>
            </>
          )}
        </>
      }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}